export default __webpack_public_path__ + "static/media/WaterPave 1.6 ratio.f6903727.png";